import React, { useState } from 'react';
import BaseEntityList from './BaseEntityList';
import { EntityDesc } from './BaseAddEntityPopup/BaseAddEntityPopup';
import Terra from 'services/apis/terra/Terra';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { fetchServices } from 'containers/store/common/actions/FetchServices';
import { Service } from 'data/terra/Service';
import ServiceConfigPopup from './ServiceDetailPopup/ServiceDetailPopup';
import { UndefinedAble } from 'data/base';

function ListService() {
  const dispatch = useDispatch();
  const [selectedService, setSelectedService] = useState<
    UndefinedAble<Service>
  >();
  const { services } = useSelector((state: RootState) => state.common);

  return (
    <div>
      <BaseEntityList<Service>
        entityName="Service"
        entities={services}
        itemsPerRow={6}
        onEntitySelected={(item: Service) => {
          setSelectedService(item);
        }}
        onSaveEntity={async (desc: EntityDesc) => {
          return Terra.service.addService(desc);
        }}
        onSaveEntityResult={result => {
          if (result.isSuccess()) {
            dispatch(fetchServices());
          }
        }}
      />
      {selectedService && (
        <ServiceConfigPopup
          service={selectedService}
          handleCloseModal={() => {
            setSelectedService(undefined);
          }}
        />
      )}
    </div>
  );
}

export default ListService;
